import SnapsnapGateway from '@/gateways/SnapsnapGateway'

export interface IRequestPWResetUseCaseParams {
  snapsnapGateway: SnapsnapGateway
}

export default class RequestPWResetUseCase implements BaseUseCase {
  snapsnapGateway: SnapsnapGateway

  constructor({ snapsnapGateway }: IRequestPWResetUseCaseParams) {
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { email: string }) {
    try {
      await this.snapsnapGateway.Auth.forgotPassword(params)
    } catch (error) {
      throw error
    }
  }
}
